// extracted by mini-css-extract-plugin
export var option = "_42-0";
export var optionCard = "_42-f";
export var optionContent = "_42-g";
export var optionIcon = "_42-i";
export var optionIconBox = "_42-h";
export var optionLabel = "_42-j";
export var optionPill = "_42-m";
export var optionPillBadge = "_42-p";
export var optionPillIcon = "_42-n";
export var optionPillLabel = "_42-o";
export var optionRadio = "_42-k";
export var optionRadioInner = "_42-l";
export var optionReveal = "_42-2";
export var optionRevealDelay0 = "_42-3";
export var optionRevealDelay1 = "_42-4";
export var optionRevealDelay10 = "_42-d";
export var optionRevealDelay11 = "_42-e";
export var optionRevealDelay2 = "_42-5";
export var optionRevealDelay3 = "_42-6";
export var optionRevealDelay4 = "_42-7";
export var optionRevealDelay5 = "_42-8";
export var optionRevealDelay6 = "_42-9";
export var optionRevealDelay7 = "_42-a";
export var optionRevealDelay8 = "_42-b";
export var optionRevealDelay9 = "_42-c";
export var optionSelected = "_42-1";